import { useMemo } from "react";
import { useSubscriptionsStore } from "../../Subscriptions/store/subscriptions";

export function useMonthlyRevenue() {
  const { subscriptions } = useSubscriptionsStore();

  return useMemo(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const monthlyTotals = Array(12).fill(0);

    subscriptions.forEach((subscription) => {
      const createdAt = new Date(subscription.created_at);

      if (
        createdAt.getFullYear() === currentYear &&
        subscription.status.toLowerCase() === "paid"
      ) {
        const month = createdAt.getMonth();

        // Parse price to a number (strip any currency symbols if present)
        const price = typeof subscription.price === "string"
          ? parseFloat(subscription.price.replace(/[^0-9.-]+/g, ""))
          : subscription.price;

        if (!isNaN(price)) {
          monthlyTotals[month] += price;
        }
      }
    });

    return monthlyTotals;
  }, [subscriptions]);
}
